import { render, staticRenderFns } from "./UpdatePositionPage.vue?vue&type=template&id=562ac930&scoped=true"
import script from "./UpdatePositionPage.vue?vue&type=script&lang=js"
export * from "./UpdatePositionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ac930",
  null
  
)

export default component.exports